import axios from "axios";
export default async function saveCartRecord(cartNumber,relevantUrl, name) {
    //p_command : 'stop' || 'drive  

    const payload = {
        cartNumber,
        recordName: name
    }
    console.log(relevantUrl +`/admin/saveCartRecord`);

    let response = null;

    try {
        const { data } = response =  await axios.post(relevantUrl +`/admin/saveCartRecord`, payload);
        
        if(!data)
            throw new Error('NO DATA');

        if(data.status === 'ok'){
            return 'ok';
        }else{
            console.log("ERROR saveCartRecord" ,data);
            return 'error';
        }
    } catch (error) {
        console.log("ERROR saveCartRecord" ,error);
        return 'error';
    }
}